import { orderBy } from 'lodash'
import { useMemo } from 'react'
import { useGetActiveOpportunities } from './useGetActiveOpportunities'

export const useGetFeaturedJobs = () => {
    const [ActiveOpportunity, refetch] = useGetActiveOpportunities(null)

    const orderedJobs = useMemo(() => {
        return orderBy(ActiveOpportunity.data, (dt) => +dt.id, "desc")
    }, [ActiveOpportunity.data])

    return {
        orderedJobs,
        refetch
    }
}
